import { Fragment } from 'react';
import { Button } from '@monksflow/monks-ui';
import { HeartIcon, PlusIcon, Trash2Icon } from 'lucide-react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldLabel, FormSection, PersonaTextField } from '../../PersonaFormSections';
import { isNestedFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

export function CaresAboutSection() {
  const { t } = useTranslation('audiences');

  const { control, caresAboutArray } = useEditPersonaFormContext();
  const { fields, append, remove } = caresAboutArray;
  const canDelete = fields.length > 1;

  return (
    <FormSection
      icon={<HeartIcon />}
      title={t('audiences.caresAboutSection.caresAbout')}
      headerAction={
        <Button
          size="sm"
          onClick={() =>
            append({
              item: '',
              description: '',
            })
          }
        >
          {t('audiences.caresAboutSection.addItem')}
          <PlusIcon />
        </Button>
      }
    >
      <div className="grid grid-cols-[1fr_2fr_auto] items-start gap-x-4 gap-y-6">
        <FieldLabel required={isNestedFieldRequired('caresAbout', 'item')}>
          {t('audiences.caresAboutSection.item')}
        </FieldLabel>
        <FieldLabel required={isNestedFieldRequired('caresAbout', 'description')}>
          {t('audiences.caresAboutSection.description')}
        </FieldLabel>
        <span />

        {fields.map((field, index) => (
          <Fragment key={field.id}>
            <Controller
              name={`caresAbout.${index}.item`}
              control={control}
              render={({ field: itemField, fieldState: { error } }) => (
                <PersonaTextField
                  {...itemField}
                  aria-label={t('audiences.caresAboutSection.item')}
                  placeholder={t('audiences.caresAboutSection.item')}
                  multiline
                  maxRows={8}
                  error={error?.message}
                />
              )}
            />
            <Controller
              name={`caresAbout.${index}.description`}
              control={control}
              render={({ field: descField, fieldState: { error } }) => (
                <PersonaTextField
                  {...descField}
                  aria-label={t('audiences.caresAboutSection.description')}
                  placeholder={t('audiences.caresAboutSection.description')}
                  multiline
                  maxRows={4}
                  error={error?.message}
                />
              )}
            />
            <Button
              variant="ghost"
              size="icon"
              // Tessra has no ghost-destructive variant; the red is the affordance.
              className="mt-0.5 text-destructive"
              aria-label={t('audiences.caresAboutSection.removeItem')}
              onClick={() => remove(index)}
              disabled={!canDelete}
            >
              <Trash2Icon />
            </Button>
          </Fragment>
        ))}
      </div>
    </FormSection>
  );
}
